import React from 'react';

function Contact() {
  return (
    <section>
      <h2>where you can find me</h2>
      <p>email: qu.carolyn@gmail.com</p>
      <a href="https://www.linkedin.com/in/qucarolyn" target="_blank" rel="noopener noreferrer">linkedin.com/qucarolyn</a>
    </section>
  );
}

export default Contact;